import { IsalesCreditRetentionType } from "../../common/utils/AirPnlRetentionRate/AirPnlTypes";
import colors from "../../common/utils/colors";

export function BuildPie(mappedDataSeries: IsalesCreditRetentionType[]) {
  return {
    chart: {
      type: "pie",
    },
    colors,
    credits: {
      enabled: false,
    },
    drilldown: {
      series: [],
    },
    legend: {
      labelFormat: "{pclabel}: {percentage:.0f}%",
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        dataLabels: {
          distance: 1,
          enabled: true,
          format: "{point.pclabel}: {point.percentage:.0f}%",
        },
        shadow: false,
        showInLegend: false,
      },
    },
    series: [
      {
        data: mappedDataSeries,
        name: "Retention rate",
        showInLegend: false,
      },
    ],
    title: {
      text: "",
    },
    tooltip: {
      headerFormat: "</br>",
      pointFormat: `PC mnemo: {point.pcmnemo} <br> PC label: {point.pclabel} <br> Retention rate (BV/SC): <b>{point.retentionrate}%</b>`,
    },
  };
}
